import CrudDataTable from 'components/DataTable/CrudDataTable'
import ROUTE from 'constant/route'
import { UOMContract } from 'models'
import { useUOMsContext } from 'pages/UOMsPage/context/UOMsContext'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, useHistory } from 'react-router-dom'
import nameof from 'utilities/nameof'

const fields = nameof<UOMContract>()

function CustomUOMLookupTable() {
    const { t } = useTranslation()
    const {
        customUOMs,
        uomsTableHeaders,
        loading,
        processing,
        onRemoveUOMs,
        onUpdateDefaultUOM,
    } = useUOMsContext()
    const history = useHistory()

    const onClickNewUOM = useCallback(() => {
        history.replace(ROUTE.UOM_NEW)
    }, [history])

    const onClickEachUOM = useCallback(
        (row: UOMContract) => {
            const path = generatePath(ROUTE.UOM_EDIT, {
                id: row.uomid!,
            })
            history.replace(path)
        },
        [history],
    )

    const onRemoveSelectedUOMs = useCallback(
        (selectedUOMs: UOMContract[]) => {
            const uomIDs = selectedUOMs.flatMap((i) => i.uomid!)
            onRemoveUOMs(uomIDs)
        },
        [onRemoveUOMs],
    )

    return (
        <CrudDataTable
            data={customUOMs}
            headers={uomsTableHeaders}
            itemKey={fields.uomid}
            loading={loading}
            hideSearchField
            newButtonText={t('uoms.title.new_uom')}
            onNew={onClickNewUOM}
            onRowClick={onClickEachUOM}
            onDelete={onRemoveSelectedUOMs}
            disabled={processing}
            onToggleSwitch={(_, uom) => onUpdateDefaultUOM(uom.uomid!)}
            rowOption={{
                disabledSelect: (uom: UOMContract) =>
                    uom.isDefault || !uom.isConversionModifiable,
            }}
        />
    )
}

export default CustomUOMLookupTable
